import { useEffect } from "react";
import { content_groupActions } from "../actions";
import { useDispatch, useSelector } from "react-redux";

export const useCardImageLoaderHook = ({
  organization_id,
  dependency,
  querySelector,
}) => {
  const dispatch = useDispatch();
  const { replace_image } = useSelector(s => s.content_group)

  useEffect(() => {
    replace_image && replace_image.map((data, i) => {
      if(data && data.attachment) {
        var replaceImage = document.querySelector(`#find_div_${data.id} img:not(.drag-icon-image)`);
        if (!!replaceImage) {
          replaceImage.src = data.attachment.icon_square.url;
        }
      }
    })
  }, [replace_image, dependency])

  useEffect(() => {
    const timer = setTimeout(() => {
    const visibleDivObserver = new IntersectionObserver((entries, imgObserver) => {
      var collect_id = []
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const find_value = entry.target
          if (find_value.getAttribute('data-image-pending') == 'true') {
            collect_id.push(find_value.getAttribute('data-id'));
            find_value.setAttribute('data-image-pending', 'false');
          }
        }
      })
      if(collect_id.length > 0) {
        var content_groups_id = collect_id;
        dispatch(content_groupActions.replaceOrganizationImageLazyLoading(organization_id, content_groups_id ));
      }
    });
    var visible_div = document.querySelectorAll(querySelector);

    console.log(visible_div)

    visible_div.forEach((v) => {
      visibleDivObserver.observe(v);
    })
  }, 300);
  return () => clearTimeout(timer);
  }, [dependency]);

  return null
};